var Box = (function(){

    function Box(){
        THREE.Object3D.call(this);

        this.container = new THREE.Object3D();
        this.add(this.container);

        var geometry = new THREE.BoxGeometry(100, 100, 100);
        var material = new THREE.MeshBasicMaterial({color: 0x3facc8, wireframe: true, transparent: true});
        this.mesh = new THREE.Mesh(geometry, material);
        this.container.add(this.mesh);

        geometry = new THREE.SphereGeometry(20);
        material = new THREE.MeshBasicMaterial({color: 0xeb4357, wireframe: true, transparent: true});
        this.contentMesh = new THREE.Mesh(geometry, material);
        this.container.add(this.contentMesh);
    }

    Box.prototype = new THREE.Object3D;
    Box.prototype.constructor = Box;

    Box.prototype.update = function(t) {
        this.container.rotation.x += 0.01;
        this.container.rotation.y += 0.01;
        this.container.position.z = Math.cos(t) * 150;
        this.container.position.y = Math.sin(t) * 150;
        this.mesh.scale.x = Math.cos(t) + 1 + 0.4;
        this.mesh.scale.y = Math.cos(t * 0.1) + 1 + 0.4;

        this.contentMesh.position.y = Math.cos(t * 10) * 30;
    };

    return Box;
})();